import * as jQuery from 'jquery';
import { Store, combineReducers } from 'redux';
import { DialogConfig } from './../../common/models/DialogConfig';
import { IAuthProvider } from './../../common/providers/DialogAuthProvider';

import {
    InitializeAction,
    AddLikeAction,
    RemoveLikeAction,
    AddTabNotificationAction,
    AddMessageAction,
    AddBookmarkAction,
    RemoveBookmarkAction,
    RemoveMessageAction,
    AddCommentAction,
    FeedReadyAction,
    CommentAddedAction,
    LikeAddedAction,
    LikeRemovedAction
} from '../actions';
import { ActivityAddedAction } from '../actions/ActivityAddedAction';

(window as any).jQuery = typeof(jQuery) === "object" ? (jQuery as any).default : jQuery;
const SR = require('signalr');
const $ = (window as any).jQuery;

export class LegacySignalRProvider {
    private _fuseHub: any;
    public constructor(
        private _config: DialogConfig,
        private _store: Store,
        private _authProvider: IAuthProvider) {
            let hubs = this._config.ServiceUrl + this._config.SignalRHub + '/hubs';
            this._loadHubsScript(hubs);
    }
    public initialize() {
        if($.connection.fuseHub) {
            this._initializeHub();
            return;
        }
        let readyWait = setInterval(() => {
            if($.connection.fuseHub) {
                clearInterval(readyWait);
                this._initializeHub();
            }
        }, 200);
    }
    public close() {
        $.connection.hub.stop();
    }
    public changeTab(id: string, sequence: number) {
        this._fuseHub.server.switchedTab(id, sequence);
    }
    public search(tabId: string, text: string) {
        this._fuseHub.server.addSearch(tabId, text);
    }
    public setFilter(tabId: string, filters: any[]) {
        this._fuseHub.server.setFilter(tabId, filters);
    }
    public setReadLater(messageId: number, value: boolean) {
        this._fuseHub.server.setReadLater(messageId, value);
    }
    public showMore(tabId: string, lastActivityId: number, pageNumber: number) {
        this._fuseHub.server.showMoreResults(tabId, lastActivityId, pageNumber);
    }
    public deleteMessage(id: number) {
        this._fuseHub.server.deleteActivity(id);
    }
    public addComment(parentIds: number[], comment: string) {
        console.log(parentIds);
        if(parentIds.length === 1) {
            this._fuseHub.server.commentOnActivity(parentIds[0], comment);
        }
        else if(parentIds.length === 2) {
            this._fuseHub.server.commentOnComment(parentIds[1], comment);
        }
    }
    public deleteComment(ids: number[]) {
        if(ids.length === 2) {
            this._fuseHub.server.deleteComment(ids[0], ids[1]);
        }
        if(ids.length === 3) {
            this._fuseHub.server.deleteCommentComment(ids[1], ids[2]);
        }
    }
    public addLike(parentIds: number[], like: boolean) {
        console.log(parentIds);
        if(parentIds.length === 1) {
            this._fuseHub.server.likeActivity(parentIds[0], like);
        }
        if(parentIds.length === 2) {
            this._fuseHub.server.likeComment(parentIds[1], like);
        }
        if(parentIds.length === 3) {
            this._fuseHub.server.likeCommentComment(parentIds[2], like);
        }
    }
    private _initializeHub()
    {
        let lastLogin = this._authProvider.lastLogin;
        this._fuseHub = $.connection.fuseHub;
        this._registerHandlers();
        $.connection.hub.url = this._config.ServiceUrl + this._config.SignalRHub;
        $.connection.hub.qs = {
            axx: this._authProvider.getToken(),
            t: '',
            m: ''
        };
        $.connection.hub.reconnecting(function() {
            console.log('reconnecting');
        });
        
        $.connection.hub.reconnected(function() {
            console.log('reconnected');
        });
        
        $.connection.hub.disconnected(function() {
            console.log('disconnected');
        });
        $.connection.hub
        .start({ transport: ['webSockets', 'longPolling'] })
        .done(function () {
            //$.connection.fuseHub.server.initialize();
            $.connection.fuseHub.server.initialize(lastLogin.toLocaleString());
        })
        .fail(function () {
            console.log('fail');
        });
    }
    private _loadHubsScript(url: string) {
        let el = document.createElement('script');
        el.src = url;
        document.getElementsByTagName('head')[0].appendChild(el);
    }
    private _registerHandlers() {
        this._fuseHub.client.initialized = (data: any) => {
            this._store.dispatch(Object.assign({}, new InitializeAction({ tabs: data.ts, categroies: data.cs, enableLinkPreview: this._config.EnableLinkPreview , enableMessageSnippets: this._config.EnableMessageSnippets })));
        };
        this._fuseHub.client.sendTabNotification = (data: any) => {
            console.log(data);
        };
        this._fuseHub.client.onActivitiesLoaded = (data: any) => {
            this._store.dispatch(Object.assign({}, new FeedReadyAction(data)));
        };
        this._fuseHub.client.updateTabAlerts = (data: any) => {
            console.log(data);
        };

        this._fuseHub.client.sendActivityUnliked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeRemovedAction({ ids: [+data.i], user: data })));
        }

        this._fuseHub.client.sendActivityLiked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeAddedAction({ ids: [+data.i], user: data })));
        }

        this._fuseHub.client.sendCommentUnliked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeRemovedAction({ ids: [-1, +data.i], user: data })));
        }

        this._fuseHub.client.sendCommentLiked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeAddedAction({ ids: [-1, +data.i], user: data })));
        }

        this._fuseHub.client.sendCommentCommentUnliked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeRemovedAction({ ids: [-1, -1, +data.i], user: data })));
        }

        this._fuseHub.client.sendCommentCommentLiked = (data: any) => {
            this._store.dispatch(Object.assign({}, new LikeAddedAction({ ids: [-1, -1, +data.i], user: data })));
        }

        this._fuseHub.client.sendActivityUnbookmarkedByYou = (data: any) => {
            console.log(data);
        }

        this._fuseHub.client.sendActivityBookmarkedByYou = (data: any) => {
            console.log(data);
        }

        this._fuseHub.client.sendRemoveActivityComment = (data: any) => {
            console.log(data);
        };

        this._fuseHub.client.sendActivityAdded = (data: any) => {
            this._store.dispatch((Object.assign({}, new ActivityAddedAction(data))));
        };

        this._fuseHub.client.sendRemoveActivity = (data: any) => {
            console.log(data);
        };

        this._fuseHub.client.sendPostRenderActivityComment = (data: any) => {
            //nothing to do
        };

        this._fuseHub.client.sendNewActivityComment = (data: any) => {
            this._store.dispatch((Object.assign({}, new CommentAddedAction({ parentIds: [+data.ai], comment: data }))));
        };

        this._fuseHub.client.sendNewActivityCommentComment = (data: any) => {
            this._store.dispatch((Object.assign({}, new CommentAddedAction({ parentIds: [-1, +data.ai], comment: data }))));
        };

        this._fuseHub.client.addTabActivities = (data: any) => {
            this._store.dispatch((Object.assign({}, new AddMessageAction({ messages: data, globalLikes: this._config.GlobalAllowLikes, globalComments: this._config.GlobalAllowComments }))));
        };
    }
}